export default {
  toasts: {
    load_error: 'Não foi possível carregar as faturas.',
    action_error: 'A ação falhou — tente novamente.',
    finalized: 'Fatura finalizada.',
    marked_paid: 'Fatura marcada como paga.',
  },
  filters: {
    status: 'Filtrar por estado',
  },
  volume_discount_badge: 'Desconto por volume aplicado ({{licenses}} licenças, {{percent}}%)',
  columns: {
    description: 'Fatura',
    status: 'Estado',
    total: 'Total',
    paid_at: 'Pago em',
  },
  statuses: {
    pending: 'Pendente',
    processing: 'Em processamento',
    paid: 'Pago',
    failed: 'Falhado',
    refunded: 'Reembolsado',
    partially_refunded: 'Parcialmente reembolsado',
  },
  companies: {
    partner_level: 'Ajustes ao nível do parceiro',
    columns: {
      company: 'Restaurante',
      buckets: 'Posições',
      amount: 'Valor',
    },
  },
  buckets: {
    license_fees: 'Taxas de licença',
    service_fees: 'Taxas de serviço',
    processing_fees: 'Taxas de processamento',
    delivery_fees: 'Taxas de entrega',
    gift_card_fees: 'Taxas de cartão oferta',
    adjustments: 'Ajustes',
  },
  entries: {
    count: '{{count}} entradas',
    columns: {
      description: 'Entrada',
      occurred_at: 'Data',
      amount: 'Valor',
    },
  },
  incl_tax: 'incl. {{amount}} IVA',
  actions: {
    open_invoice_pdf: 'Descarregar fatura (PDF)',
    open_hosted: 'Abrir fatura no Stripe',
    export_csv: 'Exportar CSV',
    finalize: 'Finalizar no Stripe',
    mark_paid: 'Marcar como paga',
  },
  finalize: {
    title: 'Finalizar esta fatura no Stripe?',
    description:
      'Ao finalizar inicia-se a cobrança: com um método de pagamento guardado, o débito é automático; caso contrário, o parceiro recebe a fatura alojada.',
    confirm: 'Finalizar',
  },
  mark_paid: {
    pushed_note:
      'Esta fatura já está no Stripe — o rascunho será eliminado (ou uma fatura finalizada marcada como paga fora de banda) para o Stripe parar de cobrar.',
    title: 'Marcar esta fatura como paga?',
    description:
      'Regista um pagamento manual (offline) de {{amount}}. Use isto para transferências bancárias cobradas fora do Stripe.',
    confirm: 'Marcar como paga',
  },
  settlement_badge: {
    paid: 'Receita partilhada paga: {{amount}}',
    other: 'Pagamento de receita partilhada {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Pagamentos de receita partilhada',
    retry: 'Repetir',
    toasts: {
      load_error: 'Não foi possível carregar os pagamentos.',
      retry_error: 'A repetição falhou — tente novamente.',
      retry_paid: 'Receita partilhada paga.',
      retry_attempted: 'Repetição efetuada — o pagamento ainda não foi concluído, verifique o estado.',
    },
    columns: {
      period: 'Período',
      amount: 'Valor',
      status: 'Estado',
      transfer: 'Transferência',
      paid_at: 'Pago em',
      payout: 'Pagamento',
    },
    payout: {
      direct: '{{amount}}, sem conversão',
      direct_tooltip:
        'Devido {{owed}}, convertido a 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} e enviado tal como está: sem conversão da Stripe, sem taxa.',
      converted: 'Enviado {{sent}} → chegou {{arrived}}',
      expected: 'Enviado {{sent}} → esperado {{arrived}}',
      fee: 'Taxa de conversão da Stripe {{amount}}',
      net: 'líquido {{amount}}',
      pending_details: 'A taxa e o valor líquido aparecem assim que a Stripe liquidar a transferência.',
      tooltip:
        'Devido {{owed}}. Convertido a 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, enviado do saldo da plataforma em {{source_currency}}, e convertido pela Stripe a 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. A Stripe deduz {{fee_rate}}% à chegada.',
    },
    statuses: {
      pending: 'Pendente',
      held: 'Retido',
      processing: 'Em processamento',
      paid: 'Pago',
      failed: 'Falhado',
      reversed: 'Revertido',
    },
    hold_reasons: {
      kyc_incomplete: 'O parceiro ainda não concluiu a verificação da conta de pagamento.',
      transfers_inactive: 'A conta de pagamento ainda não pode receber transferências.',
      insufficient_platform_balance: 'O saldo da plataforma não consegue cobrir este pagamento neste momento.',
      manual_hold: 'Retido manualmente.',
      missing_fx_rate:
        'Ainda não há uma taxa de câmbio guardada para a moeda de pagamento. É repetido automaticamente.',
      unsupported_payout_currency:
        'A Stripe não pode efetuar este pagamento na moeda da conta de pagamento a partir do saldo da plataforma.',
      amount_too_small: 'O valor devido é inferior à transferência mínima da Stripe para esta moeda.',
    },
  },
};
